import React, { useEffect, useState } from 'react';
import size from 'lodash/size';

import {
  useGetOfferDetails,
  usePostOffer,
} from '../../../hooks/react-query/useAdmin';
import { MapperOfferCheckDetails } from '../../../utils/importDriver/mapper';
import { NoDataFound } from '../../elements/noDataFound';
import Container from '../../elements/container';
import NewCustomerForm from './newCustomerForm';
import OfferDetails from './offerDetails';
import CustomerDetails from './customerDetails';
import DocumentComponent from './documentComponent';
import { BackButton, CustomModal } from '../../ui';
import OfferCheckStatus from './offerCheckStatus';
import { ModalFooter } from '../../elements/modalFooter';
import { toast } from '../../ui/Toast/useToast';
import { CardSkeletion } from '../../elements/skeletions/skeletions';
import { TabList } from '../../ui/TabList';
import Loader from '../../elements/loader';

const OfferCheckDetails = ({ rowData, handleBackButton }) => {
  const [disabled, setBtnDisabled] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [loader, setLoader] = useState(false);

  const [offerDetailsData1, setOfferDetailsData] = useState(null);
  const [openRejectionModal, setRejectionModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [cncCode] = useState(rowData?.cncode);
  const [docsValues, setDocsValue] = useState({});
  const [customerFormValue, setCustomerFormValue] = useState({});

  const { data: offerDetailsData, isLoading } = useGetOfferDetails(
    rowData?.cncode
  );

  const { mutate: handleSubmitOffer } = usePostOffer();
  const { actions, customerDetails, customerForm, offerDetails, documents } =
    offerDetailsData1 || {};

  useEffect(() => {
    if (offerDetailsData) {
      setOfferDetailsData(MapperOfferCheckDetails(offerDetailsData));
    }
  }, [offerDetailsData]);

  useEffect(() => {
    let docCodes = [];
    documents?.data.forEach((item) => {
      docCodes.push(item.docCode.value);
    });
    const uniqueDocCodes = [...new Set(docCodes)];
    if (
      !size(customerFormValue[cncCode]) ||
      size(docsValues[cncCode]) !== uniqueDocCodes.length
    ) {
      !disabled && setBtnDisabled(true);
    } else {
      disabled && setBtnDisabled(false);
    }
  }, [docsValues, cncCode, disabled, customerFormValue, documents?.data]);

  if (isLoading) {
    return (
      <Container>
        <div className="grid lg:grid-cols-2 gap-5">
          <div className="h-full flex flex-col gap-6">
            <CardSkeletion />
            <CardSkeletion />
          </div>
          <div className="h-full flex flex-col gap-6">
            <CardSkeletion />
          </div>
        </div>
      </Container>
    );
  }

  if (
    !offerDetailsData ||
    (offerDetailsData && !offerDetailsData.data) ||
    !offerDetailsData1
  ) {
    return (
      <Container>
        <NoDataFound />
      </Container>
    );
  }

  const handleDocsChange = (docData, name) => {
    const cncode = docData.cncode;
    const newData = {};
    newData[cncode] = {
      ...docsValues[cncode],
      [docData.docCode.value]: name,
    };

    setDocsValue(newData);
  };

  const handleCustomerFormChange = (id, value) => {
    const allCustomerFormsStatus = {
      [cncCode]: {
        [id]: value,
      },
    };

    setCustomerFormValue(allCustomerFormsStatus);
  };

  const handleOfferReject = (value, action) => {
    setRejectionModalOpen(value);
    setModalData(!!value ? action : null);
  };

  const handleCloseModal = () => {
    setRejectionModalOpen(false);
    setModalData(null);
  };

  const handleSubmit = (type) => {
    setLoader(true);
    let payload = '';
    if (type !== 'finalRejection') {
      const docs = docsValues[cncCode];
      const keys = Object.keys(docs);
      const documentsList = {};
      documents.data.forEach((item) => {
        if (keys.includes(item.docCode.value)) {
          documentsList[item.id] = docs[item.docCode.value];
        }
      });
      payload = {
        docsArray: {
          ...customerFormValue[cncCode],
          ...documentsList,
        },
      };
    }

    handleSubmitOffer(
      {
        url: modalData.url,
        payload,
      },
      {
        onSuccess: (response) => {
          setLoader(false);
          setRejectionModalOpen(false);
          setModalData(null);
          if (response?.status === 'success') {
            if (response.exceptions) {
              if (size(response.exceptions) > 0) {
                const message =
                  response.exceptions.slice(-1) ||
                  'Παρουσιάστηκε κάποιο πρόβλημα';

                toast({
                  variant: 'destructive',
                  description: message,
                });
              }
            }
            toast({
              variant: 'success',
              description: response?.message,
            });
          } else if (response?.status === 'fail') {
            toast({
              variant: 'destructive',
              description: response?.message || 'Παρουσιάστηκε κάποιο πρόβλημα',
            });
          } else {
            toast({
              variant: 'destructive',
              description: 'Παρουσιάστηκε κάποιο πρόβλημα',
            });
          }
          handleBackButton();
        },
      }
    );
  };

  return (
    <>
      {loader && <Loader />}
      <Container>
        <div className="flex flex-col gap-6 overflow-y-auto min-h-[100vh-300px] scrollbar pb-32">
          <div className="flex flex-col gap-2">
            <BackButton
              text="Back to Offers Check"
              handleBackClick={handleBackButton}
            />
            <h1 className="h1">Offers Check Details</h1>
          </div>

          <TabList
            className="rounded-md w-full items-center justify-center"
            wrapperClassName="self-center w-full lg:hidden"
            tabs={['Offer info', 'Documentation']}
            active={activeTab}
            setActive={(value) => setActiveTab(value)}
          />

          <div className={`grid lg:grid-cols-2 gap-5`}>
            <div
              className={`h-full flex flex-col gap-6 ${
                activeTab === 1 && 'max-lg:hidden'
              }`}
            >
              <OfferDetails offerDetails={offerDetails} />
              <CustomerDetails customerDetails={customerDetails} />
            </div>
            <NewCustomerForm
              cncCode={cncCode}
              activeTab={activeTab}
              customerForm={customerForm}
              customerFormValue={customerFormValue}
              handleCustomerFormChange={handleCustomerFormChange}
            />
          </div>
          <div
            className={`flex flex-col gap-8 ${
              activeTab === 0 && 'max-lg:hidden'
            }`}
          >
            <h3>Υποβληθέντα Δικαιολογητικά</h3>
            <div className="grid lg:grid-cols-2 gap-x-6 gap-y-8">
              {documents.data.map((documentData, index) => {
                return (
                  <DocumentComponent
                    docsVal={docsValues}
                    docData={documentData}
                    key={`${documentData.docCode}-${index}`}
                    handleDocsChange={handleDocsChange}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </Container>
      <div className="fixed bottom-0 w-full lg:h-[94px] h-fit  bg-white flex items-center justify-center pb-8">
        <div className="flex max-lg:flex-col max-lg:pt-4 max-lg:w-full max-lg:px-6  gap-3 self-end">
          {actions.map((action) => {
            const { id, label, name } = action;
            return (
              <CustomModal
                key={id}
                triggerClass={
                  name === 'reject'
                    ? 'btn btn-secondary text-secondary-button lg:order-1 order-2'
                    : 'btn btn-primary text-secondary text-primary-button lg:order-2 order-1'
                }
                triggerComponent={<>{label}</>}
                wrapperClass="lg:max-h-[80vh] h-[100vh]"
                handleClick={(value) => handleOfferReject(value, action)}
                openModal={openRejectionModal}
                disabled={name === 'documentstatus' ? disabled : false}
              >
                <div className="container-sm mx-auto lg:py-10 py-5 lg:px-[80px] px-5">
                  <div className="flex flex-col gap-10 justify-center items-center">
                    {modalData && modalData.name === 'documentstatus' ? (
                      <OfferCheckStatus
                        cncCode={cncCode}
                        modalData={modalData}
                        customerForm={customerForm}
                        customerFormValue={customerFormValue}
                        docsValues={docsValues}
                        documents={documents}
                        handleCancelClick={handleCloseModal}
                        handleSubmit={handleSubmit}
                      />
                    ) : (
                      <>
                        <h3 className="max-lg:self-start">
                          {modalData && modalData.label}-{cncCode}
                        </h3>
                        <p className="text-body">
                          Είστε σίγουροι πως θέλετε να οριστικοποιήσετε την
                          επιλογή σας; Η ενέργεια αυτή δεν μπορεί να αναιρεθεί.
                        </p>
                        <div className="flex gap-3 items-center justify-center max-lg:w-full">
                          <ModalFooter
                            handleCancelClick={handleCloseModal}
                            handleOkClick={() => handleSubmit('finalRejection')}
                            saveBtnText="Επιβεβαίωση"
                            className="max-lg:flex-col max-lg:col-reverse max-lg:w-full"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </CustomModal>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default OfferCheckDetails;
